module.exports = "<div #portalHost></div>\r\n"